import _app from '../../../server';

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import {
    summons_approve,
    summon_archive
} from 'redux/actions/summons'

import {
    Button,
    Card, CardBody,
    Row,
    Form, FormGroup,
    Input, InputGroup, InputGroupAddon,
    FormFeedback
} from 'reactstrap';

import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

const moment = require('moment');

class Transactions extends Component {
    static propTypes = {
        summon: PropTypes.object,
        dispatch: PropTypes.func,
        history: PropTypes.object,
        transactions: PropTypes.array,
        auth: PropTypes.object
    }

    constructor(props) {
        super(props)
        this.state = {
            fine: '',
            fineInvalid: false,
            fineErr: '',
            remark: '',
            remarkInvalid: false,
            remarkErr: ''
        }
    }

    onFineChange = (e) => { this.setState({ fine: e.target.value }) }
    onRemarkChange = (e) => { this.setState({ remark: e.target.value }) }

    onFineDismiss = () => { this.setState({ fineInvalid: false, fineErr: '' }) }
    onRemarkDismiss = () => { this.setState({ remarkInvalid: false, remarkErr: '' }) }

    onApprove = () => {
        const { dispatch, summon } = this.props;
        const { fine } = this.state;

        if (fine === '' || fine === 0 || fine === '0') {
            this.setState({ fineInvalid: true, fineErr: 'Please enter amount to be fined' })
            return
        }

        confirmAlert({
            title: 'Confirm to accept',
            message: `Fine RM ${fine}`,
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => { dispatch(summons_approve(summon.id, fine, null, this.onApproveErr)) }
                },
                {
                    label: 'No'
                }
            ]
        });
    }
    onApproveErr = (e) => {
        const { history } = this.props
        if (!e) {
            history.replace('/traffic/issued')
            return
        }
        this.setState({ fineInvalid: true, fineErr: `${e.name} : ${e.message}` })
    }

    onArchive = () => {
        const { dispatch, summon } = this.props
        const { remark } = this.state
        if (remark === '') {
            this.setState({ remarkInvalid: true, remarkErr: 'Please enter the reason' })
            return
        }

        confirmAlert({
            title: 'Confirm to archived',
            message: `Permanently move the record to archive`,
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => { dispatch(summon_archive(summon.id, remark, this.onArchiveError)) }
                },
                {
                    label: 'No'
                }
            ]
        });

    }
    onArchiveError = (err) => {
        const { history } = this.props
        if (!err) {
            history.replace('/traffic/issued')
            return
        }
        this.setState({ remarkInvalid: true, remarkErr: `${err.name} : ${err.message}` })
    }

    render() {
        const { auth, transactions } = this.props;

        let flip = false;
        let log = transactions.map((log) => {
            let clr = 'text-primary'
            if (flip) {
                clr = 'text-muted'
            }
            flip = !flip
            return (
                <CardBody key={log.id} className="bg-transparent border-l-2 p-0 pl-2">
                    <div className={clr}><b>{log.summoner.name}</b>{'\u00A0'}<span><small>{moment(log.timestamp).format("YYYY/MM/DD hh:mm:ss A")}</small></span></div>
                    <small>{log.summoner.staffId} : {log.summoner.email} / {log.summoner.phoneNumber}</small>
                    <hr />
                    <CardBody style={{ marginLeft: '20px', paddingTop: '0px' }}>
                        {log.remark}
                    </CardBody>
                </CardBody>
            )
        })

        return (
            <React.Fragment>
                <Card className="bg-transparent border-0">
                    <CardBody>
                        <Row>
                            <div className="font-2xl display-4 text-muted font-italic ml-2 mb-3 text-left">Log:</div>
                        </Row>
                        {transactions.length < 1 &&
                            <p>No transaction record available</p>
                        }
                        {transactions.length > 0 &&
                            log
                        }
                    </CardBody>
                </Card>
                <hr />
                {(_app.dashboard !== auth.info.profile.email) &&
                    <React.Fragment>
                        <Form onSubmit={(e) => { e.preventDefault() }} className="w-75 m-auto">
                            <FormGroup>
                                <InputGroup size='sm'>
                                    <InputGroupAddon addonType="prepend">
                                        <Button disabled style={{ minWidth: '100px' }}>Fine (RM)</Button>
                                    </InputGroupAddon>
                                    <Input type='number' invalid={this.state.fineInvalid} value={this.state.fine} onChange={this.onFineChange} onFocus={this.onFineDismiss}></Input>
                                    <InputGroupAddon addonType="append">
                                        <Button onClick={this.onApprove} color='success' style={{ minWidth: '100px' }}>Approve</Button>
                                    </InputGroupAddon>
                                    <FormFeedback onClick={this.onFineDismiss} valid className="text-center" style={{ backgroundColor: 'white' }}>{this.state.fineErr}</FormFeedback>
                                    <FormFeedback onClick={this.onFineDismiss} className="text-center" style={{ backgroundColor: 'white' }}>{this.state.fineErr}</FormFeedback>
                                </InputGroup>
                            </FormGroup>
                        </Form>
                        <Form onSubmit={(e) => { e.preventDefault() }} className="w-75 m-auto">
                            <FormGroup>
                                <InputGroup size='sm' style={{ minWidth: '100px' }}>
                                    <InputGroupAddon addonType="prepend">
                                        <Button disabled style={{ minWidth: '100px' }}>Remark</Button>
                                    </InputGroupAddon>
                                    <Input invalid={this.state.remarkInvalid} value={this.state.remark} onChange={this.onRemarkChange} onFocus={this.onRemarkDismiss}></Input>
                                    <InputGroupAddon addonType="append">
                                        <Button onClick={this.onArchive} color='danger' style={{ minWidth: '100px' }}>Archive</Button>
                                    </InputGroupAddon>
                                    <FormFeedback onClick={this.onRemarkDismiss} valid className="text-center" style={{ backgroundColor: 'white' }}>{this.state.remarkErr}</FormFeedback>
                                    <FormFeedback onClick={this.onRemarkDismiss} className="text-center" style={{ backgroundColor: 'white' }}>{this.state.remarkErr}</FormFeedback>
                                </InputGroup>
                            </FormGroup>
                        </Form>
                    </React.Fragment>
                }
            </React.Fragment>
        )
    }
}

export default Transactions



// WEBPACK FOOTER //
// ./src/components/features/Transactions/Transactions.js